import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const MobileMenu = ({ isOpen, setIsOpen }) => (
  <>
    <div className="sm:hidden flex items-center">
      <button
        type="button"
        className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-hover-charcoal focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
        aria-controls="mobile-menu"
        aria-expanded={isOpen ? 'true' : 'false'}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="sr-only">Open main menu</span>
        {isOpen ? (
          <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
        ) : (
          <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
        )}
      </button>
    </div>
    <div
      className={`${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } fixed inset-0 z-50 bg-charcoal bg-opacity-90 transition-transform duration-300 ease-in-out`}
    >
      <div className="flex items-center justify-end p-4">
        <button
          type="button"
          className="text-gray-400 hover:text-white"
          onClick={() => setIsOpen(false)}
        >
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <div className="flex flex-col items-center space-y-4 mt-20">
        <Link
          to="#"
          className="flex items-center justify-center text-sm font-medium bg-red-700 rounded-full w-48 h-12 hover:bg-hover-charcoal"
        >
          Log In
        </Link>
        <Link
          to="#"
          className="flex items-center justify-center text-sm font-medium text-gray-300 hover:text-white"
        >
          Sign Up
        </Link>
      </div>
    </div>
  </>
);

export default MobileMenu;